/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 血圧測定部位
 */
export type VitalBtPartEnum =
  (typeof VitalBtPartEnum)[keyof typeof VitalBtPartEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VitalBtPartEnum = {
  AXILLA: 'AXILLA',
  TYMPANIC_MEMBRANE: 'TYMPANIC_MEMBRANE',
  NON_CONTACT: 'NON_CONTACT',
} as const;
